{
  "badge_soon": "เร็วๆ นี้",
  "action": {
    "collapse": "ย่อแถบเมนู",
    "expand": "ขยายแถบเมนู"
  },
  "coming_soon_page": {
    "subtitle": "โมดูลนี้ยังไม่พร้อมใช้งาน",
    "heading": "{{module}} กำลังจะมาเร็วๆ นี้",
    "body": "เรากำลังพัฒนาโมดูลนี้ และจะเปิดให้ใช้งานในรุ่นถัดไป ระหว่างนี้โมดูลคลังสินค้าและสัดส่วนคลังพร้อมใช้งานเต็มรูปแบบ"
  },
  "group": {
    "operations": "ปฏิบัติการ",
    "fulfillment": "การจัดส่ง",
    "integrations": "การเชื่อมต่อ",
    "promotion": "โปรโมชั่น",
    "reports": "รายงาน",
    "admin": ""
  },
  "coming_soon": "เร็วๆ นี้",
  "item": {
    "dashboard": "",
    "orders": "คำสั่งซื้อ",
    "inventory": "คลังสินค้า",
    "inventory_diff": "ส่วนต่างสต๊อก",
    "inventory_ratio": "สัดส่วนคลัง",
    "sku_brands": "แบรนด์ของ SKU",
    "campaign": "แคมเปญ",
    "promotion": "โปรโมชั่น",
    "promotion_report": "รายงานโปรโมชั่น",
    "inbound_report": "รายงานสต๊อกเข้า",
    "revenue_report": "รายงานรายได้",
    "export_orders": "ส่งออกคำสั่งซื้อ",
    "orders_export": "ส่งออกออเดอร์",
    "split": "แยกออเดอร์",
    "returns": "คืนสินค้า",
    "users": "",
    "audit_log": "",
    "marketplace_connections": "การเชื่อมต่อมาร์เก็ตเพลส",
    "manual_review": "ตรวจสอบด้วยตนเอง",
    "notifications": "การแจ้งเตือน",
    "notifications_unread": "การแจ้งเตือนที่ยังไม่ได้อ่าน"
  },
  "badge_attention": "{{n}} ออเดอร์ต้องตรวจสอบ"
}
